<template>
  <b-card>
    <div class="d-flex justify-content-between">
      <b-card-title class="font-weight-bolder text-header-card-pic" style="color: #ffbb33">
        Ofertas Relâmpago Exclusivas
        <img src="@/assets/images/icons/ofertas-icons/clarao.png" alt="Oferta"/>
      </b-card-title>
      <!-- <b-card-title class="font-weight-bolder text-header-card-pic">
        <b-link href="/app/ecommerce/production-item" style="color: #ffbb33">Ver mais
          <feather-icon icon="ChevronRightIcon" size="25"/>
        </b-link>
      </b-card-title> -->
    </div>
    <swiper
        class="swiper-responsive-breakpoints"
        :options="swiperOptions"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    >
      <swiper-slide v-for="(data, index) in picGenereca" :key="index" style="cursor: pointer;">
        <b-img :src="data.item_img_principal" fluid style="height: 300px;object-fit: contain;" @click="itemSelecionado(data)"/>
        <!-- <div class="offer-flag-container">
          <img src="@/assets/images/icons/ofertas-icons/super-oferta-32.png" alt="Oferta"/>
        </div> -->
        <count-second-promocao :segundos-ate-termino="data.secondTime" />
        <div v-if="true" class="badge badge-danger">{{ `Ofertas Relâmpago Exclusivas ${data.porcentagem_desconto}%` }}</div>
        <div v-if="!ocultarEstoque" class="process-bottom">
          <b-progress
              v-b-tooltip.hover
              :title="`${data.picitemquantidade - data.picitemquantidadesaldo} Vendidos`"
              :max="data.picitemquantidadesaldo" class="progress-bar-danger" variant="warning" style="height: 20px;">
            <b-progress-bar :value="data.picitemquantidade - data.picitemquantidadesaldo" variant="red"
                            style="height: 20px;">
            </b-progress-bar>
            <div class="position-absolute w-100 text-center" style="top: 50%; transform: translateY(-50%);">
              <strong class="text-center" style="font-weight: bold;color: black">{{
                  `${data.picitemquantidade - data.picitemquantidadesaldo} Vendidos`
                }}</strong>
            </div>
          </b-progress>
        </div>
      </swiper-slide>
      <div slot="button-next" class="swiper-button-next"/>
      <div slot="button-prev" class="swiper-button-prev"/>
    </swiper>
    <ModalPromocaoSelected
    id="modal-promocao-selected"
    />
  </b-card>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { BImg, VBTooltip } from 'bootstrap-vue';
import 'swiper/css/swiper.css';
import BCardActions from '@core/components/b-card-actions/BCardActions.vue';
import { mapGetters } from 'vuex';
import CountSecondPromocao from '@/views/home/components/CountSecondPromocao.vue';
import ModalPromocaoSelected from '@/components/modal/ModalPromocao.vue';
import { isPerfilClienteAtivo } from '@/libs/perfilCliente';
import { ocultarEstoqueCertificacao, tipoPedidoSelecionadoParaEstoque } from '@/utils/estoqueVisibilidade';

export default {
  components: {
    ModalPromocaoSelected,
    CountSecondPromocao,
    BCardActions,
    Swiper,
    SwiperSlide,
    BImg,
  },
  data() {
    return {
      max: 100,
      value: 50,
      color: 'light-warning',
      /* eslint-disable global-require */
      swiperData: [
        { img: require('@/assets/images/pages/content-img-2.jpg') },
        { img: require('@/assets/images/pages/content-img-2.jpg') },
        { img: require('@/assets/images/pages/content-img-2.jpg') },
        { img: require('@/assets/images/pages/content-img-2.jpg') },
        { img: require('@/assets/images/pages/content-img-2.jpg') },
        { img: require('@/assets/images/pages/content-img-2.jpg') },
        { img: require('@/assets/images/pages/content-img-2.jpg') },
        { img: require('@/assets/images/pages/content-img-2.jpg') },
        { img: require('@/assets/images/pages/content-img-2.jpg') },
      ],
      /* eslint-disable global-require */

      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 50,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  computed: {
    ocultarEstoque() {
      return isPerfilClienteAtivo() || ocultarEstoqueCertificacao(tipoPedidoSelecionadoParaEstoque(this.$store));
    },
    ...mapGetters('PicStore', {
      picGenereca: 'GET_PIC_GENERICAS',
    }),
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  methods: {
    itemSelecionado(item) {
      console.log('itemSelecionado', item);
      console.log('PIC GENERICA', this.picGenereca);
      item.quantidade = item.picitemquantidadesaldo;
      this.$store.commit('InfoPedido/SET_ITEM_PROMOCAO_SELECTED', item);
      console.log('ABRIR MODAL modal-promocao-selected');
      this.$bvModal.show('modal-promocao-selected');
    },
  },
};
</script>
<style scoped>
.offer-flag-container {
  position: absolute;
  top: 12px;
  right: 37px;
  width: auto;
  height: auto;
}

.badge {
  position: absolute;
  top: 30px;
  right: 0;
  font-size: 0.8rem;
  z-index: 999;
  padding: 5px 10px;
  background: #ffbb33;
  border-radius: 5px 0 0 0;
}

.process-bottom {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  padding: 6px 10px;
}

@media screen and (max-width: 768px) {
  .text-header-card-pic {
    font-size: 0.8rem !important;
  }

  .text-header-card-pic img {
    width: 20px;
  }

  .text-header-card-pic svg {
    height: 20px;
  }

}
</style>
